module.exports = __webpack_public_path__ + "img/tema-3-2.18212bb0.svg";